import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "Éducatif",
  icon: "🧠",
  templates: [
    {
      title: "Expliquez Simplement",
      content: `Expliquez le sujet de [comment les vaccins entraînent le système immunitaire] de manière claire et engageante pour les auditeurs.
- Imaginez que vous l'expliquez à [un adolescent curieux sans connaissances scientifiques].
- Utilisez une analogie accessible : [comparez cela à un exercice d'évacuation incendie — on s'entraîne pour être prêt quand la situation réelle se présente].
- Évitez le jargon ; quand un terme technique est nécessaire, définissez-le immédiatement en langage courant.
- Écrivez sur un ton chaleureux et encourageant qui donne à l'auditeur le sentiment d'être intelligent, sans condescendance.`
    },
    {
      title: "Voix Off de Documentaire",
      content: `Écrivez une narration en voix off de style documentaire.
- Sujet : [la vie quotidienne des vendeurs de street food à Bangkok].
- Angle : [le savoir-faire, la fierté et les connaissances générationnelles derrière des plats qui semblent simples mais nécessitent des années de maîtrise].
- Ton : [respectueux, vivant et posé — laissez les scènes respirer].
- Incluez des détails sensoriels qui aident l'auditeur à visualiser et ressentir l'environnement : [le grésillement d'un wok, l'humidité du marché matinal, les gestes précis d'un vendeur qui fait cela depuis dix mille fois].
- Écrivez au présent pour l'immédiateté.`
    },
    {
      title: "Méditation Guidée",
      content: `Écrivez un script de méditation guidée conçu pour être écouté.
- Objectif : [relâcher les tensions après une longue journée de travail et entrer doucement dans la soirée].
- Guidez l'auditeur à visualiser [un bord de lac paisible au coucher du soleil — une lumière chaude sur l'eau, une brise douce, le son d'oiseaux lointains qui se posent pour la nuit].
- Ton : [calme, posé et ancrant].
- Durée parlée approximative : [8 minutes].
- Utilisez de nombreuses pauses naturelles (indiquées par "...") entre les instructions. Gardez les phrases courtes et douces. Évitez les changements brusques d'énergie.`
    }
  ]
};
